/* eslint-disable no-use-before-define */
import router from './router';

const auth = {};


/**
 * If the user isn't logged in, redirect them to login component
 *
 * NOTE: Change this cookie name for each event!
 */
auth.requireLogin = () => {
  if (getCookie('loggedInMasterplan2021') === 'true') return;

  router.push('/login');

  /**
   * Get a cookie value by its name
   *
   * @param  {str} name
   * @return {str}
   */
  // eslint-disable-next-line consistent-return
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }
};


/**
 * Register that a login has occurred by triggering a "loggedInMasterplan2021" cookie,
 * then redirect to homepage
 */
auth.registerLogin = () => {
  document.cookie = 'loggedInMasterplan2021=true';
  router.push('/');
};


export default auth;



// WEBPACK FOOTER //
// ./src/auth.js